import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HomeContentMcMakler } from './experience/_contentMcMakler';
import { HomeContentEduarea } from './experience/_contentEduarea';
import { HomeContentWBT } from './experience/_contentWBT';
import { HomeContentPrinta } from './experience/_contentPrinta';

export const HomeSectionExperience = props => (
  <div className='check-list color-blue'>
    <div className='check-list-item'>
      <div className='check-list-item-progress'>
        <div
          className='check-list-item-index check-list-item-index--enormous'>
          <FontAwesomeIcon icon={['fas', 'briefcase']}/>
        </div>
        <div className='check-list-item-sep'>
        </div>
      </div>
      <div className='check-list-item-body'>
        <h2 className='uppercase'>Work experience</h2>
        <p/>
      </div>
    </div>
    <HomeContentMcMakler />
    <HomeContentEduarea />
    <HomeContentWBT />
    <HomeContentPrinta />
  </div>
);
